import { Col, Row } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import Button from 'components/Button/index'
import Export from 'components/Export'
import ExportTransfer from 'components/ExportTransfer/index.js'
import RoutePath from 'components/RoutePath'
import Select from 'components/Select'
import TreeSelect from 'components/TreeSelect'
import FilterChipComponent from 'components/UIComponents/FilterChipComponent'
import {
  JobRoleFlex,
  JobRoleWholeFlex,
  LeftSection,
  SectionName,
  TopHeading,
} from 'modules/JobRoles/PageHeader/style.js'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ToggleThreeOptions from '../../../components/UIComponents/Toggle/ToggleThreeOptions'
import { roleExportKeys } from '../../../utils/const'
import { FilterLabel, RightSection } from './style'

const PageHeader = ({
  yearData,
  handleYearChange,
  yearValue,
  state,
  handleDomainChange,
  handleDegreeChange,
  handleDepartmentChange,
  stateList,
  handleRemoveFilter,
  handleTabClick,
  handleExportClick,
  handleDomainSearch,
  handleDepartmentSearch,
  handleDegreeSearch,
  exportMenu,
  exportOpen,
  exportLoading,
  setExportOpen,
  handleExportOpen,
  jobCategories,
  accessLevel,
}) => {
  const [showModal, setShowModal] = useState(false)

  const [targetKeys, setTargetKeys] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [transfer, setTransfer] = useState(false)
  const [exportType, setExportType] = useState('')
  const [data, setData] = useState([])

  const columns = [
    {
      dataIndex: 'title',
      title: 'Name',
    },
  ]

  const handleTransferClick = async isOpen => {
    try {
      if (isOpen) {
        let fieldDatas = roleExportKeys

        fieldDatas = fieldDatas.map((item, index) => {
          return {
            key: index,
            title: item,
          }
        })
        setData(fieldDatas)
      } else {
        setData([])
      }
      setSelectedKeys([])
      setTargetKeys([])
      setTransfer(isOpen)
    } catch (error) {}
  }

  const handleExportType = value => {
    if (exportType == value) {
      setExportType('')
    } else {
      setExportType(value)
    }
  }
  const labelChangeFunction = label => {
    switch (label) {
      case 'PLACEMENT':
        return 'Placement'
      case 'GIGS':
        return 'Gigs'
      case 'INTERNSHIP':
        return 'Internships'
      case 'INTERNSHIP_PPO':
        return 'Internship + PPO'
      case 'APPRENTICESHIP':
        return 'Apprenticeship'
    }
  }
  const jobCategoryFilterData = data => {
    if (data?.length > 0) {
      let jobCat = data.map(item => ({
        label: labelChangeFunction(item),
        value: item,
      }))
      return jobCat
    }
  }
  useEffect(() => {
    jobCategoryFilterData(jobCategories)
  }, [jobCategories])
  const filterFunction = data => {
    if (Array.isArray(data)) {
      return data.flatMap(({ domain, degree }, domainIndex) => {
        if (Array.isArray(degree) && degree?.length > 0) {
          return degree?.flatMap(({ degree, department }, degreeIndex) => {
            if (Array.isArray(department) && department?.length > 0) {
              return department.flatMap(
                ({ department: departmentName }, departmentIndex) => {
                  return {
                    label: `${domain} - ${degree} - ${departmentName}`,
                    indices: {
                      domainIndex: domainIndex,
                      degreeIndex: degreeIndex,
                      departmentIndex: departmentIndex,
                    },
                  }
                }
              )
            } else {
              return {
                label: `${domain} - ${degree}`,
                indices: {
                  domainIndex: domainIndex,
                  degreeIndex: degreeIndex,
                },
              }
            }
          })
        } else {
          return {
            label: `${domain}`,
            indices: {
              domainIndex: domainIndex,
            },
          }
        }
      })
    }
  }

  const filterArr = filterFunction(state.selectedCourses)

  const navigate = useNavigate()
  const handleAddRole = () => {
    navigate('/jobRoles/newRole')
  }
  const [selectedKeys, setSelectedKeys] = useState([])

  const handleShowFilterClick = () => {
    if (showModal) {
      setShowModal(false)
    } else {
      setShowModal(true)
    }
  }
  return (
    <JobRoleWholeFlex>
      <JobRoleFlex>
        <LeftSection centerVertically>
          <SectionName column>
            <RoutePath from="Job Role" path="/jobRoles" />
            <TopHeading> Overview</TopHeading>
          </SectionName>
        </LeftSection>
        <RightSection centerVertically>
          <Export
            label="Export"
            overlayMenu={exportMenu}
            open={exportOpen}
            setOpen={setExportOpen}
            onOpenChange={handleExportOpen}
            exportLoading={exportLoading}
          />
        </RightSection>
      </JobRoleFlex>

      <JobRoleFlex>
        <ToggleThreeOptions
          tabs={[
            ...(jobCategoryFilterData(jobCategories) ?? []),
            { label: 'Archive', value: 'ARCHIVED' },
          ]}
          current={state.selectedCategory}
          handleClick={e => handleTabClick(e)}
        />
        <RightSection centerVertically>
          <div
            style={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              gap: 10,
            }}
          >
            {accessLevel === 1 || accessLevel === 3 ? (
              <Button.Primary onClick={handleAddRole} text="Add New Role" />
            ) : null}
          </div>
        </RightSection>
      </JobRoleFlex>

      <Row gutter={16}>
        <Col
          md={5}
          xs={24}
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <FilterLabel>Domain</FilterLabel>
          <FormItem style={{ width: '100%' }}>
            <TreeSelect
              showArrow={false}
              filterTreeNode={false}
              treeData={stateList.domainList || []}
              treeCheckable={true}
              placeholder="Select Domain"
              maxTagCount={0}
              showSearch={true}
              onChange={handleDomainChange}
              placeholderSize={'12px'}
              labelInValue
              shadowBox
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              onSearch={data => handleDomainSearch(data)}
              height={'auto'}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              value={state.selectedDomain}
              listHeight={180}
            />
          </FormItem>
        </Col>
        <Col
          md={5}
          xs={24}
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <FilterLabel>Degree</FilterLabel>
          <FormItem style={{ width: '100%' }}>
            <TreeSelect
              showArrow={false}
              filterTreeNode={false}
              treeData={stateList.degreeList || []}
              treeCheckable={true}
              placeholder="Select Degree"
              maxTagCount={0}
              showSearch={true}
              placeholderSize={'12px'}
              onChange={handleDegreeChange}
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              shadowBox
              disabled={state?.selectedDomain?.length === 0}
              onSearch={data => handleDegreeSearch(data)}
              height={'auto'}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              value={state.selectedDegree || []}
              listHeight={180}
            />
          </FormItem>
        </Col>
        <Col
          md={5}
          xs={24}
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <FilterLabel>Depart.</FilterLabel>
          <FormItem style={{ width: '100%' }}>
            <TreeSelect
              showArrow={false}
              filterTreeNode={false}
              treeData={stateList.departmentList || []}
              treeCheckable={true}
              placeholder="Select Department"
              maxTagCount={0}
              placeholderSize={'12px'}
              showSearch={true}
              onChange={handleDepartmentChange}
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              shadowBox
              disabled={state?.selectedDegree?.length === 0}
              onSearch={data => handleDepartmentSearch(data)}
              height={'auto'}
              value={state.selectedDepartment || []}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              listHeight={180}
            />
          </FormItem>
        </Col>

        <Col md={6} xs={24} style={{ display: 'flex' }}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              gap: 10,
              data,
            }}
          >
            <FilterLabel whiteSpace="pre">Passing Year</FilterLabel>
            <FormItem style={{ width: '100%', marginBottom: '15px' }}>
              <Select
                showSearch={true}
                allowClear={true}
                OptionData={yearData}
                placeholder="Select Year"
                valueParam="year"
                nameParam="year"
                colorstyle={true}
                value={yearValue}
                onChange={handleYearChange}
                filterOption={(input, option) => {
                  const childrenString = option.children
                    .toString()
                    .toLowerCase()
                  return childrenString.includes(input.toLowerCase())
                }}
                listHeight={180}
                boxShadow="rgba(123, 97, 255, 0.15) 0px 2px 6px 0px"
              />
            </FormItem>
          </div>
        </Col>
      </Row>
      {filterArr?.length > 0 && (
        <FilterChipComponent
          data={filterArr || []}
          handleClick={handleShowFilterClick}
          open={showModal}
          handleRemoveFilter={handleRemoveFilter}
        />
      )}
      <ExportTransfer
        open={transfer}
        handleClose={handleTransferClick}
        data={data}
        columns={columns}
        disabled={disabled}
        setDisabled={setDisabled}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        exportType={exportType}
        handleExportType={handleExportType}
        handleExportClick={handleExportClick}
      />
    </JobRoleWholeFlex>
  )
}

export default PageHeader